import React, { useState, useEffect } from "react";
import { Tab, Nav, Form } from "react-bootstrap";
import { supabase } from "../../supabaseClient";
import SystemStorage from "./SystemStorage";
import "../../assets/css/FileManagement.css";
import { FiRefreshCw, FiSearch, FiFilter } from "react-icons/fi";

const FileManagement = () => {
  const [activeTab, setActiveTab] = useState("system");
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("all");

  useEffect(() => {
    const fetchUser = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      if (session) {
        setUserId(session.user.id);
      }
      setLoading(false);
    };
    fetchUser();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "60px 0",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <FiRefreshCw
            style={{
              fontSize: "32px",
              color: "var(--teal-bg)",
              animation: "spin 1s linear infinite",
            }}
          />
          <span style={{ color: "var(--text)", opacity: 0.7 }}>Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="file-management-container">
      {/* Compact Header Row */}
      <div className="fm-header-row">
        <div className="fm-header-left">
          <div className="fm-icon-box">
            <i className="bi bi-folder-fill"></i>
          </div>
          <div className="fm-header-text">
            <h5 className="fm-title">File Management</h5>
            <span className="fm-subtitle">Manage your files and storage</span>
          </div>
        </div>

        {/* Tabs in header */}
        <div className="fm-header-tabs">
          <button
            className={`fm-header-tab ${activeTab === "system" ? "active" : ""}`}
            onClick={() => setActiveTab("system")}
          >
            <i className="bi bi-hdd-stack"></i>
            System Storage
          </button>
          <button
            className={`fm-header-tab ${activeTab === "user" ? "active" : ""}`}
            onClick={() => setActiveTab("user")}
          >
            <i className="bi bi-person-badge"></i>
            User Storage
          </button>
        </div>
      </div>

      {/* Search and Filter Bar */}
      <div className="fm-toolbar">
        <div className="fm-search-box">
          <FiSearch className="fm-search-icon" />
          <input
            type="text"
            placeholder="Search files..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="fm-search-input"
          />
        </div>
        <div className="fm-filter-box">
          <FiFilter className="fm-filter-icon" />
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            className="fm-filter-select"
          >
            <option value="all">All Files</option>
            <option value="images">Images</option>
            <option value="documents">Documents</option>
            <option value="audios">Audio</option>
          </select>
        </div>
      </div>

      {/* Content */}
      <div className="fm-content">
        {activeTab === "system" ? (
          userId && (
            <SystemStorage
              userId={userId}
              searchQuery={searchQuery}
              filterType={filterType}
            />
          )
        ) : (
          <div className="fm-coming-soon">
            <i className="bi bi-clock-history"></i>
            <h5>User Storage</h5>
            <p>Coming soon...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileManagement;
